/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    projectId: 'loadboard-de9d9',
    appId: '1:436166284274:web:1a300f8b076b699e5a116b',
    databaseURL: 'https://loadboard-de9d9.firebaseio.com',
    storageBucket: 'loadboard-de9d9.appspot.com',
    locationId: 'europe-west',
    apiKey: 'AIzaSyDtNxXHlPnKMNUgbXRoE3qmBPH2vNj45sU',
    authDomain: 'loadboard-de9d9.firebaseapp.com',
    messagingSenderId: '436166284274',
    measurementId: 'G-RBR7WR3V23',
  },
};
